export default __webpack_public_path__ + "static/media/th-ico-active.c53b3120.svg";